import BaseModel from './BaseModel';

class Distributor extends BaseModel {
  constructor(data = {}) {
    super(data);
    this.setApiDetailsData(data)
    // this.setApiData(data)
  }

  setApiDetailsData = (data) => {
    this.id = data.id;
    this.name = data.name;
    this.wallet_balance = data.wallet_balance;
    this.mobile_number = data.mobile_number;
    this.status = data.status;
    if(data.firm) {
        this.firm_name = data.firm.name || ""
        // this.firm_pan_number = data.firm.pan_number || ""
        this.gst_number = data.firm.gst_number || ""
        this.annual_turn_over = data.firm.annual_turn_over || ""
    }

    if(data.address) {
      this.address = data.address.address  || ""
      this.pincode = data.address.pincode_code  || ""
      this.city = data.address.city  || ""
      this.state = data.address.state  || ""
    }
    if(data.address) {
      this.address = `${data.address.address} ${data.address.city || ""} ${data.address.state || ""}`;
      this.pincode = data.address.pincode_code
    }
    this.bill_finalize_by_role = data.bill_finalize_by_role;
    this.can_raise_electricity_bill = data.can_raise_electricity_bill;
    this.enabled_for_rental = data.enabled_for_rental;
    this.allocated_rental_fo = data.allocated_rental_fo;
    this.allocated_rental_service_center = data.allocated_rental_service_center;
  }

  // setApiData = (data) => {
  //   this.id = data.id;
  //   this.bill_finalize_by_role = data.bill_finalize_by_role;
  //   this.can_raise_electricity_bill = data.can_raise_electricity_bill;
  //   this.enabled_for_rental = data.enabled_for_rental;
  //   this.allocated_rental_fo = data.allocated_rental_fo;
  //   this.allocated_rental_service_center = data.allocated_rental_service_center;
  // }

}

export default Distributor;
